import { default as about7fjpVi1CRLMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/about.vue?macro=true";
import { default as _91id_93NnF006wRmjMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/cert/[id].vue?macro=true";
import { default as homeeUAe8896FyMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/home.vue?macro=true";
import { default as indexQLFhRhoPAkMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/index.vue?macro=true";
import { default as _91id_93N4jESXSMwpMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/news/[id].vue?macro=true";
import { default as index8cdRyv11WBMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/news/index.vue?macro=true";
import { default as policy7Wz2QyHWpvMeta } from "/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/policy.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "cert-id",
    path: "/cert/:id()",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/cert/[id].vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexQLFhRhoPAkMeta || {},
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("/Users/haoli/Documents/code/guoxin/ai_web/ai_pc/src/pages/policy.vue").then(m => m.default || m)
  }
]